import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const ecommerceMenu = [
  { name: "Daftar Merchant", route: "/merchant", icon: "fas fa-list" },
  { name: "Performa Merchant", route: "/merchant/performance", icon: "fas fa-chart-line" },
  { name: "Transaksi", route: "/transaction", icon: "fas fa-exchange-alt" },
  { name: "Laporan Invoice", route: "/reportinvoice", icon: "fas fa-file-invoice" },
  { name: "Laporan Invoice Lengkap", route: "/reportinvoicefull", icon: "fas fa-clipboard-list" },
  { name: "Refund", route: "/refund", icon: "fas fa-undo-alt" },
  { name: "Status Permohonan Dana", route: "/checkpayout", icon: "fas fa-search-dollar" },
  { name: "Penerimaan Permohonan Dana", route: "/approvepayout", icon: "fas fa-check-double" },
  { name: "Laporan Permohonan Dana", route: "/reportpayout", icon: "fas fa-hand-holding-usd" },
];

const kliksekolahMenu = [
  { name: "Laporan Pembayaran", route: "/reportpembayaran", icon: "fas fa-money-check-alt" },
];

const cekgudangMenu = [
  { name: "Daftar Company", route: "/cekgudang/companies", icon: "fas fa-building" },
];

const isRouteActive = (pathname, route) => (
  pathname === route || pathname.indexOf(`${route}/`) === 0
);

const getActiveGroup = pathname => {
  if (cekgudangMenu.some(item => isRouteActive(pathname, item.route))) return "cekgudang";
  if (kliksekolahMenu.some(item => isRouteActive(pathname, item.route))) return "kliksekolah";
  if (
    ecommerceMenu.some(item => isRouteActive(pathname, item.route)) ||
    pathname.indexOf("/transactiondetail/") === 0
  ) return "ecommerce";
  return "";
};

const SideNavigation = ({ isOpen, isMobile, onLinkClick, onClose }) => {
  const location = useLocation();
  const activeGroup = getActiveGroup(location.pathname);
  const [openGroup, setOpenGroup] = useState(activeGroup);

  useEffect(() => {
    if (activeGroup) setOpenGroup(activeGroup);
  }, [activeGroup]);

  const toggleGroup = group => {
    setOpenGroup(current => current === group ? "" : group);
  };

  const renderGroup = ({ key, name, icon, items, placeholder }) => {
    const isOpenGroup = openGroup === key;
    const isActiveGroup = activeGroup === key;

    return (
      <div className={`admin-sidebar__group ${isActiveGroup ? "admin-sidebar__group--active" : ""} ${isOpenGroup ? "admin-sidebar__group--open" : ""}`}>
        <button
          type="button"
          className="admin-sidebar__group-trigger"
          onClick={() => toggleGroup(key)}
          aria-expanded={isOpenGroup}
          aria-controls={`sidebar-${key}`}
        >
          <span><i className={icon} /></span>
          <strong>{name}</strong>
          {placeholder && <small className="admin-sidebar__group-badge">SEGERA</small>}
          <i className={`fas fa-chevron-${isOpenGroup ? "up" : "down"}`} />
        </button>
        {isOpenGroup && (
          <div id={`sidebar-${key}`} className="admin-sidebar__submenu">
            {items && items.map(item => (
              <NavLink
                key={item.route}
                exact
                to={item.route}
                activeClassName="admin-sidebar__sublink--active"
                onClick={onLinkClick}
              >
                <i className={item.icon} />
                <span>{item.name}</span>
              </NavLink>
            ))}
            {placeholder && (
              <div className="admin-sidebar__placeholder">
                <i className="fas fa-tools" />
                <div>
                  <strong>Menu sedang disiapkan</strong>
                  <small>Modul Cekgudang akan tersedia di sini.</small>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isMobile && isOpen && (
        <button
          type="button"
          className="admin-sidebar-overlay"
          onClick={onClose}
          aria-label="Tutup navigasi"
        />
      )}
      <aside className={`admin-sidebar ${isMobile ? "admin-sidebar--mobile" : ""} ${isOpen ? "admin-sidebar--open" : ""}`}>
        <div className="admin-sidebar__brand">
          <span><img src="/payment-console-icon.svg" alt="" /></span>
          <div><strong>SPIN Management</strong><small>Unified Admin Portal</small></div>
          {isMobile && (
            <button type="button" onClick={onClose} aria-label="Tutup navigasi">
              <i className="fas fa-times" />
            </button>
          )}
        </div>

        <div className="admin-sidebar__workspace">
          <span className="admin-sidebar__workspace-icon"><i className="fas fa-layer-group" /></span>
          <div><small>ACTIVE WORKSPACE</small><strong>All Operations</strong></div>
        </div>

        <nav className="admin-sidebar__nav" aria-label="Navigasi utama">
          <span className="admin-sidebar__label">OVERVIEW</span>
          <NavLink
            exact
            to="/dashboard"
            className="admin-sidebar__link"
            activeClassName="admin-sidebar__link--active"
            onClick={onLinkClick}
          >
            <span><i className="fas fa-tachometer-alt" /></span>
            <strong>Dashboard</strong>
            <i className="fas fa-chevron-right" />
          </NavLink>

          <span className="admin-sidebar__label admin-sidebar__label--platform">BUSINESS PLATFORMS</span>
          {renderGroup({
            key: "ecommerce",
            name: "E-Commerce",
            icon: "fas fa-shopping-cart",
            items: ecommerceMenu,
          })}
          {renderGroup({
            key: "kliksekolah",
            name: "Kliksekolah",
            icon: "fas fa-school",
            items: kliksekolahMenu,
          })}
          {renderGroup({
            key: "cekgudang",
            name: "Cek Gudang",
            icon: "fas fa-warehouse",
            items: cekgudangMenu,
          })}

          <span className="admin-sidebar__label admin-sidebar__label--section">ADMINISTRASI</span>
          <NavLink exact to="/audit-log" className="admin-sidebar__link" activeClassName="admin-sidebar__link--active" onClick={onLinkClick}>
            <span><i className="fas fa-history" /></span><strong>Audit Log</strong><i className="fas fa-chevron-right" />
          </NavLink>
        </nav>

        <div className="admin-sidebar__footer">
          <span><i className="fas fa-lock" /></span>
          <div><strong>Protected workspace</strong><small>Enterprise access</small></div>
        </div>
      </aside>
    </>
  );
};

export default SideNavigation;
